interface Props {
  width: string,
  height: string,
  fill: string
    
    }

export const CurvedLeftArrow = (props:any) => {

    return  (
        <CurvedLeftArrowSvg
        width={props.width}
        height={props.height}
        fill={props.fill}
        />
    )}

export const CurvedLeftArrowSvg = ({
  width = '15px',
  height  = '15px',
  fill = '#4D4D4D'

}: Props ) => (
<svg className='curved-arrow' viewBox="0 0 22.58 26.06" width={width} height={height} fill={fill}>
  <path d="M0,13.03s5.71,4.12,11.41,7.4c5.59,3.22,11.16,5.63,11.17,5.62,0,0-7.3-13.27-7.3-13.27C15.28,12.79,22.59.01,22.58,0c0,0-5.78,2.63-11.39,5.86C5.51,9.14,0,13.02,0,13.03Z"/>
</svg>
)
export { CurvedLeftArrowSvg as ReactComponent }
